import DELIA_CLASSIC_GOLD_BG_IMAGE from '../../../assets/images/club/flavours/DELIA/gold.webp';
import DELIA_CLASSIC_GOLD_PACK_IMAGE from '../../../assets/images/club/flavours/DELIA/gold_pack.webp';
import DELIA_CLASSIC_GREEN_BG_IMAGE from '../../../assets/images/club/flavours/DELIA/green.webp';
import DELIA_CLASSIC_GREEN_PACK_IMAGE from '../../../assets/images/club/flavours/DELIA/green_pack.webp';
import DELIA_CLASSIC_RED_BG_IMAGE from '../../../assets/images/club/flavours/DELIA/red.webp';
import DELIA_CLASSIC_RED_PACK_IMAGE from '../../../assets/images/club/flavours/DELIA/red_pack.webp';
import DELIA_CLASSIC_SILVER_BG_IMAGE from '../../../assets/images/club/flavours/DELIA/silver.webp';
import DELIA_CLASSIC_SILVER_PACK_IMAGE from '../../../assets/images/club/flavours/DELIA/silver_pack.webp';
import LEVIA_ISLAND_BEAT_BG_IMAGE from '../../../assets/images/club/flavours/LEVIA/beat_island.webp';
import LEVIA_ISLAND_BEAT_PACK_IMAGE from '../../../assets/images/club/flavours/LEVIA/beat_island_pack.webp';
import LEVIA_GLACIAL_BEAT_BG_IMAGE from '../../../assets/images/club/flavours/LEVIA/glacial_beat.webp';
import LEVIA_GLACIAL_BEAT_PACK_IMAGE from '../../../assets/images/club/flavours/LEVIA/glacial_beat_pack.webp';
import LEVIA_ELECTRO_PURPLE_BG_IMAGE from '../../../assets/images/club/flavours/LEVIA/purple.webp';
import LEVIA_ELECTRO_PURPLE_PACK_IMAGE from '../../../assets/images/club/flavours/LEVIA/purple_pack.webp';
import TEREA_AMBER_BG_IMAGE from '../../../assets/images/club/flavours/TEREA/amber.webp';
import TEREA_AMBER_PACK_IMAGE from '../../../assets/images/club/flavours/TEREA/amber_pack.webp';
import TEREA_SIENA_BG_IMAGE from '../../../assets/images/club/flavours/TEREA/sienna.webp';
import TEREA_SIENA_PACK_IMAGE from '../../../assets/images/club/flavours/TEREA/sienna_pack.webp';
import TEREA_TURQUOISE_BG_IMAGE from '../../../assets/images/club/flavours/TEREA/turq.webp';
import TEREA_TURQUOISE_PACK_IMAGE from '../../../assets/images/club/flavours/TEREA/turq_pack.webp';
import TEREA_YELLOW_BG_IMAGE from '../../../assets/images/club/flavours/TEREA/yellow.webp';
import TEREA_YELLOW_PACK_IMAGE from '../../../assets/images/club/flavours/TEREA/yellow_pack.webp';
import deviceSticksTypes from '../../../consts/device/deviceSticksTypes';
import {strCode} from '../../../consts/strCode';

const propertiesTypes = {
    AROMA_LEVEL: 'aromaLevel',
    INTENSITY_LEVEL: 'intensityLevel',
    BODY_LEVEL: 'bodyLevel',
    COOLING_LEVEL: 'coolingLevel',
};

const flavourTypes = {
    TEREA_TURQUOISE: 'TEREA_TURQUOISE',
    TEREA_SIENNA: 'TEREA_SIENNA',
    TEREA_AMBER: 'TEREA_AMBER',
    TEREA_YELLOW: 'TEREA_YELLOW',
    LEVIA_GLACIAL_BEAT: 'LEVIA_GLACIAL_BEAT',
    LEVIA_ISLAND_BEAT: 'LEVIA_ISLAND_BEAT',
    LEVIA_ELECTRO_PURPLE: 'LEVIA_ELECTRO_PURPLE',
    DELIA_CLASSIC_GOLD: 'DELIA_CLASSIC_GOLD',
    DELIA_CLASSIC_GREEN: 'DELIA_CLASSIC_GREEN',
    DELIA_CLASSIC_RED: 'DELIA_CLASSIC_RED',
    DELIA_CLASSIC_SILVER: 'DELIA_CLASSIC_SILVER',
};

const flavoursConfig = {
    [deviceSticksTypes.TEREA]: {
        [flavourTypes.TEREA_TURQUOISE]: {
            imagePackSrc: TEREA_TURQUOISE_PACK_IMAGE,
            imageBgSrc: TEREA_TURQUOISE_BG_IMAGE,
            titleStrCode: strCode.CLUB_PAGE_FLAVOURS_TEREA_TURQUOISE_TITLE,
            descriptionStrCode: strCode.CLUB_PAGE_FLAVOURS_TEREA_TURQUOISE_DESCRIPTION,
            properties: {
                [propertiesTypes.INTENSITY_LEVEL]: 2,
            },
        },
        [flavourTypes.TEREA_SIENNA]: {
            imagePackSrc: TEREA_SIENA_PACK_IMAGE,
            imageBgSrc: TEREA_SIENA_BG_IMAGE,
            titleStrCode: strCode.CLUB_PAGE_FLAVOURS_TEREA_SIENNA_TITLE,
            descriptionStrCode: strCode.CLUB_PAGE_FLAVOURS_TEREA_SIENNA_DESCRIPTION,
            properties: {
                [propertiesTypes.INTENSITY_LEVEL]: 4,
            },
        },
        [flavourTypes.TEREA_AMBER]: {
            imagePackSrc: TEREA_AMBER_PACK_IMAGE,
            imageBgSrc: TEREA_AMBER_BG_IMAGE,
            titleStrCode: strCode.CLUB_PAGE_FLAVOURS_TEREA_AMBER_TITLE,
            descriptionStrCode: strCode.CLUB_PAGE_FLAVOURS_TEREA_AMBER_DESCRIPTION,
            properties: {
                [propertiesTypes.INTENSITY_LEVEL]: 5,
            },
        },
        [flavourTypes.TEREA_YELLOW]: {
            imagePackSrc: TEREA_YELLOW_PACK_IMAGE,
            imageBgSrc: TEREA_YELLOW_BG_IMAGE,
            titleStrCode: strCode.CLUB_PAGE_FLAVOURS_TEREA_YELLOW_TITLE,
            descriptionStrCode: strCode.CLUB_PAGE_FLAVOURS_TEREA_YELLOW_DESCRIPTION,
            properties: {
                [propertiesTypes.INTENSITY_LEVEL]: 3,
            },
        },
    },
    [deviceSticksTypes.LEVIA]: {
        [flavourTypes.LEVIA_GLACIAL_BEAT]: {
            imagePackSrc: LEVIA_GLACIAL_BEAT_PACK_IMAGE,
            imageBgSrc: LEVIA_GLACIAL_BEAT_BG_IMAGE,
            titleStrCode: strCode.CLUB_PAGE_FLAVOURS_LEVIA_GLACIAL_BEAT_TITLE,
            descriptionStrCode: strCode.CLUB_PAGE_FLAVOURS_LEVIA_GLACIAL_BEAT_DESCRIPTION,
            properties: {
                [propertiesTypes.AROMA_LEVEL]: 3,
                [propertiesTypes.COOLING_LEVEL]: 4,
            },
        },
        [flavourTypes.LEVIA_ISLAND_BEAT]: {
            imagePackSrc: LEVIA_ISLAND_BEAT_PACK_IMAGE,
            imageBgSrc: LEVIA_ISLAND_BEAT_BG_IMAGE,
            titleStrCode: strCode.CLUB_PAGE_FLAVOURS_LEVIA_ISLAND_BEAT_TITLE,
            descriptionStrCode: strCode.CLUB_PAGE_FLAVOURS_LEVIA_ISLAND_BEAT_DESCRIPTION,
            properties: {
                [propertiesTypes.AROMA_LEVEL]: 3,
                [propertiesTypes.COOLING_LEVEL]: 3,
            },
        },
        [flavourTypes.LEVIA_ELECTRO_PURPLE]: {
            imagePackSrc: LEVIA_ELECTRO_PURPLE_PACK_IMAGE,
            imageBgSrc: LEVIA_ELECTRO_PURPLE_BG_IMAGE,
            titleStrCode: strCode.CLUB_PAGE_FLAVOURS_LEVIA_ELECTRO_PURPLE_TITLE,
            descriptionStrCode: strCode.CLUB_PAGE_FLAVOURS_LEVIA_ELECTRO_PURPLE_DESCRIPTION,
            properties: {
                [propertiesTypes.AROMA_LEVEL]: 4,
                [propertiesTypes.COOLING_LEVEL]: 3,
            },
        },
    },
    [deviceSticksTypes.DELIA]: {
        [flavourTypes.DELIA_CLASSIC_GOLD]: {
            imagePackSrc: DELIA_CLASSIC_GOLD_PACK_IMAGE,
            imageBgSrc: DELIA_CLASSIC_GOLD_BG_IMAGE,
            titleStrCode: strCode.CLUB_PAGE_FLAVOURS_DELIA_CLASSIC_GOLD_TITLE,
            descriptionStrCode: strCode.CLUB_PAGE_FLAVOURS_DELIA_CLASSIC_GOLD_DESCRIPTION,
            properties: {
                [propertiesTypes.INTENSITY_LEVEL]: 3,
                [propertiesTypes.BODY_LEVEL]: 3,
                [propertiesTypes.AROMA_LEVEL]: 3,
                [propertiesTypes.COOLING_LEVEL]: 0,
            },
        },
        [flavourTypes.DELIA_CLASSIC_GREEN]: {
            imagePackSrc: DELIA_CLASSIC_GREEN_PACK_IMAGE,
            imageBgSrc: DELIA_CLASSIC_GREEN_BG_IMAGE,
            titleStrCode: strCode.CLUB_PAGE_FLAVOURS_DELIA_CLASSIC_GREEN_TITLE,
            descriptionStrCode: strCode.CLUB_PAGE_FLAVOURS_DELIA_CLASSIC_GREEN_DESCRIPTION,
            properties: {
                [propertiesTypes.INTENSITY_LEVEL]: 3,
                [propertiesTypes.BODY_LEVEL]: 3,
                [propertiesTypes.AROMA_LEVEL]: 2,
                [propertiesTypes.COOLING_LEVEL]: 2,
            },
        },
        [flavourTypes.DELIA_CLASSIC_RED]: {
            imagePackSrc: DELIA_CLASSIC_RED_PACK_IMAGE,
            imageBgSrc: DELIA_CLASSIC_RED_BG_IMAGE,
            titleStrCode: strCode.CLUB_PAGE_FLAVOURS_DELIA_CLASSIC_RED_TITLE,
            descriptionStrCode: strCode.CLUB_PAGE_FLAVOURS_DELIA_CLASSIC_RED_DESCRIPTION,
            properties: {
                [propertiesTypes.INTENSITY_LEVEL]: 4,
                [propertiesTypes.BODY_LEVEL]: 4,
                [propertiesTypes.AROMA_LEVEL]: 4,
                [propertiesTypes.COOLING_LEVEL]: 0,
            },
        },
        [flavourTypes.DELIA_CLASSIC_SILVER]: {
            imagePackSrc: DELIA_CLASSIC_SILVER_PACK_IMAGE,
            imageBgSrc: DELIA_CLASSIC_SILVER_BG_IMAGE,
            titleStrCode: strCode.CLUB_PAGE_FLAVOURS_DELIA_CLASSIC_SILVER_TITLE,
            descriptionStrCode: strCode.CLUB_PAGE_FLAVOURS_DELIA_CLASSIC_SILVER_DESCRIPTION,
            properties: {
                [propertiesTypes.INTENSITY_LEVEL]: 2,
                [propertiesTypes.BODY_LEVEL]: 2,
                [propertiesTypes.AROMA_LEVEL]: 3,
                [propertiesTypes.COOLING_LEVEL]: 0,
            },
        },
    },
};

export default flavoursConfig;
